import { Component, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { BenefistCardComponent } from './benefist-card/benefist-card.component';
import { CouponCardComponent } from "./coupon-card/coupon-card.component";
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { BenefitsService } from '../../services/benefits.service';
import { MatIcon } from '@angular/material/icon';
import { LoaderService } from '../../../../shared/services/loader.service';


@Component({
  selector: 'app-benefist',
  imports: [BenefistCardComponent, CouponCardComponent, CommonModule, FormsModule, MatIcon],
  templateUrl: './benefist.component.html',
  styleUrl: './benefist.component.scss'
})
export class BenefistComponent implements OnInit, AfterViewInit {
  saludBellezaMarcas: any[] = [];
  comercioServiciosMarcas: any[] = [];
  promociones: any[] = [];
  estados: any[] = [];
  categorias: any[] = [];
  showAllCoupons = false;
  todasLasMarcas: any[] = [];
  
  // Filtros seleccionados
  selectedMarca: string = '';
  selectedEstado: string = '';
  selectedCategoria: string = '';
  
  // Estado de filtrado
  isFiltered = false;
  searchResults: any[] = [];

  // Variables para navegación
  currentSaludIndex = 0;
  currentComercioIndex = 0;
  currentSearchIndex = 0;
  @ViewChild('saludContainer') saludContainer!: ElementRef<HTMLElement>;
  @ViewChild('comercioContainer') comercioContainer!: ElementRef<HTMLElement>;
  @ViewChild('searchContainer') searchContainer!: ElementRef<HTMLElement>;

  constructor(
    private benefitsService: BenefitsService,
    private loader: LoaderService
  ) {}

  ngOnInit(): void {
    this.loader.show();
    this.benefitsService.getBenefitsBrands().subscribe({
      next: (response) => {
        console.log('Benefits Brands:', response);
        const marcas = response.data.Marcas;
        this.todasLasMarcas = marcas;
        this.saludBellezaMarcas = marcas.filter(marca => marca.categoria_marca === 'Salud / Belleza');
        this.comercioServiciosMarcas = marcas.filter(marca => marca.categoria_marca === 'Comercio / Servicios');
        this.promociones = marcas.filter(marca => 
          marca.categoria_marca !== 'Salud / Belleza' && 
          marca.categoria_marca !== 'Comercio / Servicios'
        );
        this.loadAdditionalData();
      },
      error: (error) => {
        console.error('Error fetching benefits brands:', error);
        this.loader.hide();
      }
    });

  }

  private loadAdditionalData(): void {
    let completedRequests = 0;
    const totalRequests = 2;

    const checkCompletion = () => {
      completedRequests++;
      if (completedRequests >= totalRequests) {
        this.loader.hide();
      }
    };

    this.benefitsService.getCategories().subscribe({
      next: (response) => {
        console.log('Benefits Categories:', response);
        this.categorias = response.data.Categorias;
        checkCompletion();
      },
      error: (error) => {
        console.error('Error fetching benefits categories:', error);
        checkCompletion();
      }
    });

    this.benefitsService.getStates().subscribe({
      next: (response) => {
        console.log('Benefits States:', response);
        this.estados = response.data.Estados;
        checkCompletion();
      },
      error: (error) => {
        console.error('Error fetching benefits states:', error);
        checkCompletion();
      }
    });
  }

  ngAfterViewInit(): void {}

  // Métodos para navegación Salud/Belleza
  scrollSaludLeft(): void {
    if (this.currentSaludIndex > 0) {
      this.currentSaludIndex--;
      this.scrollToSalud();
    }
  }

  scrollSaludRight(): void {
    const maxIndex = this.saludBellezaMarcas.length - 1;
    if (this.currentSaludIndex < maxIndex) {
      this.currentSaludIndex++;
      this.scrollToSalud();
    }
  }

  private scrollToSalud(): void {
    if (this.saludContainer) {
      const cardWidth = 200;
      this.saludContainer.nativeElement.scrollTo({
        left: this.currentSaludIndex * cardWidth,
        behavior: 'smooth'
      });
    }
  }

  get canScrollSaludLeft(): boolean {
    return this.currentSaludIndex > 0;
  }

  get canScrollSaludRight(): boolean {
    return this.currentSaludIndex < this.saludBellezaMarcas.length - 1;
  }

  // Métodos para navegación Comercio/Servicios
  scrollComercioLeft(): void {
    if (this.currentComercioIndex > 0) {
      this.currentComercioIndex--;
      this.scrollToComercio();
    }
  }

  scrollComercioRight(): void {
    const maxIndex = this.comercioServiciosMarcas.length - 1;
    if (this.currentComercioIndex < maxIndex) {
      this.currentComercioIndex++;
      this.scrollToComercio();
    }
  }

  private scrollToComercio(): void {
    if (this.comercioContainer) {
      const cardWidth = 200;
      this.comercioContainer.nativeElement.scrollTo({
        left: this.currentComercioIndex * cardWidth,
        behavior: 'smooth'
      });
    }
  }

  get canScrollComercioLeft(): boolean {
    return this.currentComercioIndex > 0;
  }

  get canScrollComercioRight(): boolean {
    return this.currentComercioIndex < this.comercioServiciosMarcas.length - 1;
  }

  // Métodos para navegación de resultados de búsqueda
  scrollSearchLeft(): void {
    if (this.currentSearchIndex > 0) {
      this.currentSearchIndex--;
      this.scrollToSearch();
    }
  }

  scrollSearchRight(): void {
    const maxIndex = this.searchResults.length - 1;
    if (this.currentSearchIndex < maxIndex) {
      this.currentSearchIndex++;
      this.scrollToSearch();
    }
  }

  private scrollToSearch(): void {
    if (this.searchContainer) {
      const cardWidth = 200;
      this.searchContainer.nativeElement.scrollTo({
        left: this.currentSearchIndex * cardWidth,
        behavior: 'smooth'
      });
    }
  }

  get canScrollSearchLeft(): boolean {
    return this.currentSearchIndex > 0;
  }

  get canScrollSearchRight(): boolean {
    return this.currentSearchIndex < this.searchResults.length - 1;
  }

  get displayedPromociones() {
    return this.showAllCoupons ? this.promociones : this.promociones.slice(0, 6);
  }

  toggleShowAllCoupons(): void {
    this.showAllCoupons = !this.showAllCoupons;
  }

  onFilterChange(): void {
    const searchParams: any = {};
    
    if (this.selectedMarca) {
      searchParams.id_brand = Number(this.selectedMarca);
    }
    if (this.selectedEstado) {
      searchParams.state = this.selectedEstado;
    }
    if (this.selectedCategoria) {
      searchParams.id_category = Number(this.selectedCategoria);
    }
    
    // Si no hay filtros seleccionados, mostrar datos originales
    if (Object.keys(searchParams).length === 0) {
      this.isFiltered = false;
      this.searchResults = [];
      return;
    }
    
    // Mostrar loader y hacer búsqueda
    this.loader.show();
    this.benefitsService.searchBenefits(searchParams).subscribe({
      next: (response) => {
        console.log('Resultados de búsqueda:', response);
        this.searchResults = response.data?.Marcas || [];
        this.isFiltered = true;
        this.currentSearchIndex = 0;
        this.loader.hide();
      },
      error: (error) => {
        console.error('Error en búsqueda:', error);
        this.searchResults = [];
        this.isFiltered = true;
        this.loader.hide();
      }
    });
  }
}
